import moment from 'moment';
import { statuses as batchStatuses } from '@/data/billing-batch-statuses';
import { types as guideTypes } from '@/data/billing-guide-types';

export { batchStatuses, guideTypes };

export const zeroReasons = {
  return: 'Retorno',
  courtesy: 'Cortesia',
};

const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

export function currency(value) {
  return formatter.format(Number(value) || 0);
}

export function signedCurrency(value) {
  const number = Number(value) || 0;
  if (number < 0) return `−${formatter.format(Math.abs(number))}`;
  if (number > 0) return `+${formatter.format(number)}`;
  return formatter.format(0);
}

export function percent(value) {
  return `${String(Math.round((Number(value) || 0) * 10) / 10).replace('.', ',')} %`;
}

export function ruleLabel(rule) {
  if (!rule) return '—';
  if (rule.type === 'percent') return percent(rule.value);
  if (!rule.value) return '—';
  return `${currency(rule.value)} fixo`;
}

export function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  const first = parts[0][0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return `${first}${last}`.toUpperCase();
}

export function councilLabel(professional) {
  if (!professional) return '';
  const { council, specialty } = professional;
  const parts = [];
  if (council && council.name) {
    const state = council.state ? `-${council.state}` : '';
    const record = council.record ? ` ${council.record}` : '';
    parts.push(`${council.name}${state}${record}`);
  }
  if (specialty) parts.push(specialty);
  return parts.join(' · ');
}

export function selectionKey(row) {
  return `${row.origin}:${row.id}`;
}

export function isSelectable(row) {
  return row.status === 'pending' && Number(row.transfer) > 0;
}

export function groupSelection(selected) {
  const groups = new Map();
  selected.forEach((row) => {
    const key = String(row.professionalId);
    if (!groups.has(key)) {
      groups.set(key, {
        professionalId: row.professionalId,
        professional: row.professional,
        cashRegisterItemIds: [],
        medicalReportIds: [],
        total: 0,
      });
    }
    const group = groups.get(key);
    if (row.origin === 'cashRegister') {
      group.cashRegisterItemIds.push({ entryId: row.entryId, itemId: row.itemId });
    } else if (row.origin === 'medicalReport') {
      group.medicalReportIds.push(row.reportId || row.id);
    }
    group.total += Number(row.transfer) || 0;
  });
  return [...groups.values()];
}

export function pluralize(count, singular, plural) {
  return count === 1 ? singular : plural;
}

export function competenceLabel(competence) {
  const date = moment(competence, 'MM/YYYY', true);
  if (!date.isValid()) return competence || '—';
  const label = date.format('MMMM/YYYY');
  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function shiftCompetence(competence, amount) {
  const date = moment(competence, 'MM/YYYY', true);
  if (!date.isValid()) return competence;
  return date.add(amount, 'month').format('MM/YYYY');
}

export function competenceMonths(count, current) {
  const start = moment().startOf('month');
  const months = Array.from({ length: count }, (_, index) => (
    start.clone().subtract(index, 'month').format('MM/YYYY')
  ));
  const valid = current && moment(current, 'MM/YYYY', true).isValid();
  if (!valid || months.includes(current)) return months;
  return [...months, current]
    .sort((a, b) => moment(b, 'MM/YYYY').valueOf() - moment(a, 'MM/YYYY').valueOf());
}
